import FlightEntryList from './FlightEntryList';

export default FlightEntryList;
